import { cn } from "../../../../utils/utils";

const EmptyState = ({
  icon: Icon,
  title = "Chưa có dữ liệu",
  description,
  action,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center py-16 px-6",
        className,
      )}
    >
      {Icon && (
        <div className="w-14 h-14 rounded-full bg-gray-50 flex items-center justify-center mb-3">
          <Icon size={24} className="text-gray-400" />
        </div>
      )}
      <div className="text-[15px] font-semibold text-gray-800">{title}</div>
      {description && (
        <div className="text-[13px] text-gray-500 mt-1 max-w-md">
          {description}
        </div>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
